<template>
  <div id="FileManagerVue" class="xbig ybig">
    <vs-prompt
      name="fileManager"
      :vs-title="'Dosya ve Resim Yönetimi # ModuleName : ' + moduleNameProp + ' # Id : ' + moduleIdProp"
      vs-button-cancel="border"
      :vs-active="fileManagerPopupProp"
      :vs-buttons-hidden="true"
      @vs-cancel="FileManagerPopupClosedChildEmit()"
      @vs-close="FileManagerPopupClosedChildEmit()"
      @vs-accept="FileManagerPopupClosedChildEmit()"
    >
      <div class="vx-row w-full mb-5" style="justify-content:center">
        <i class="fas fa-arrow-alt-circle-right"></i>
        <vs-button class="mr-12" color="danger" @click="showPopupPictureTool = true">Resim Yükleme Sihirbazı</vs-button>
        <input type="file" class="vs-button" @change="$event.target.files != null && Object.keys($event.target.files).length > 0 ? addFiles($event) : null" />
      </div>

      <template v-if="fileList">
        <div v-for="(src, index) in fileList" :key="index">
          <div class="vx-row items-center mb-5">
            <template v-if="src.fileType == 'image'">
              <div class="vx-col w-full md:w-1/6"><img style="width=32px; height:32px;" @click="() => showImg(index)" class="mr-2" :src="src.pngBase64 == null ? DocumentSystemGetImageStream(fileList[index]) : src.pngBase64" /></div>
              <div class="vx-col md:w-1/12">
                <b><vs-checkbox v-model="src.isMainFile" @input="SaveDocumentManagementFile(src, 'SetIsMainFile')">Main</vs-checkbox></b>
              </div>
            </template>

            <template v-else>
              <div class="vx-col md:w-1/6 overflow-hidden">
                <label>{{ src.fileDescription + " " }}</label>
              </div>
              <div class="vx-col md:w-1/12">
                <feather-icon icon="DownloadIcon" @click="DocumentSystemDownloadModuleFile(fileList[index])" title="Download File" svgClasses=" hover:text-danger cursor-pointer" style="translate(11%, -10%);" />
              </div>
            </template>

            <div class="vx-col md:w-1/12">
              <feather-icon icon="TrashIcon" title="Sil" svgClasses="h-6 hover:text-danger cursor-pointer" style="margin-left:10px; translate(11%, -10%);" @click="DeleteDocumentManagementFile(src)" />
            </div>
          </div>
        </div>
      </template>

      <vue-easy-lightbox v-if="lightBoxVisible" moveDisabled :visible="lightBoxVisible" :imgs="fileList.map((p) => p.pngBase64)" :index="index" @hide="handleHide"> </vue-easy-lightbox>
    </vs-prompt>

    <vs-prompt
      style="z-index: 100001;"
      :vs-title="'Dosya ve Resim Yönetimi # ModuleName : ' + moduleNameProp + ' # Id : ' + moduleIdProp"
      vs-accept-text="Kaydet"
      vs-cancel-text="Kapat"
      vs-button-cancel="border"
      :vs-active.sync="showPopupPictureTool"
      :vs-buttons-hidden="true"
      @vs-cancel="showPopupPictureTool = false"
    >
      <div>
        <vue-anka-cropper
          :options="{
            aspectRatio: 0,
            closeOnSave: true,
            cropArea: 'box',
            croppedHeight: 400,
            croppedWidth: 400,
            cropperHeight: false,
            dropareaMessage: 'Bilgisayarınızdan resim seçiniz veya sürükleyiniz.',
            frameLineDash: [5, 3],
            frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
            handleFillColor: 'rgba(255, 255, 255, 0.2)',
            handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
            handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
            handleSize: 10,
            handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
            layoutBreakpoint: 850,
            maxCropperHeight: 768,
            maxFileSize: 8000000,
            overlayFill: 'rgba(0, 0, 0, 0.5)',
            previewOnDrag: true,
            previewQuality: 0.65,
            resultQuality: 0.8,
            resultMimeType: 'image/png',
            selectButtonLabel: 'Dosya Seçiniz',
            showPreview: true,
            skin: $store.state.theme,
            uploadData: {},
            uploadTo: false,
          }"
          @cropper-saved="saveCroppedPicture($event)"
        ></vue-anka-cropper>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";

import VueEasyLightbox from "vue-easy-lightbox";

import vueAnkaCropper from "vue-anka-cropper";
import "vue-anka-cropper/dist/VueAnkaCropper.css";

export default {
  components: { VueEasyLightbox, vueAnkaCropper },
  props: {
    fileManagerPopupProp: null,
    moduleIdProp: null,
    moduleNameProp: null,
    descriptionProp: null,
  },
  data() {
    return {
      imgPath: null,
      fileManagerItem: {
        moduleId: null,
        modulName: null,
        fileId: null,
      },
      fileList: [],
      index: null,
      showPopupPictureTool: false,
      lightBoxVisible: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    setImageToCropTool: async function(e) {
      this.imgPath = URL.createObjectURL(e.target.files[0]);
      console.log(e.target.files[0]);
    },
    changeCropper: async function(coordinates, canvas) {
      console.log(coordinates, canvas);
    },
    saveCroppedPicture: async function(e) {
      let resultConfirmForOverwrite = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        //input: "text",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });
      if (resultConfirmForOverwrite.isConfirmed) null;
      else return;

      this.$vs.loading();

      //await repository.postFileWithModuleId("General/CreateModuleFile", this.moduleName ,this.moduleIdProp, e.croppedImageURI);
      await repository.postBase64FileForDocumentManagement("General/CreateModuleFile", this.moduleIdProp, this.moduleNameProp, "image", "fileDescription", e.croppedImageURI);
      this.showPopupPictureTool = false;
      this.GetFileList();
      this.$vs.loading.close();
    },

    addFiles: async function(event) {
      if (event.target.files[0].type.includes("image")) {
        await this.$swal.fire({
          icon: "warning",
          //title: "Dikkat",
          text: "Resim yüklemelerini resim sihirbazından yapınız.",
          //showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Tamam",
          cancelButtonText: "Hayır",
        });
        return;
      }
      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        text: "Lütfen ekleyeceğiniz dosya hakkında kısa açıklama giriniz",
        input: "text",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();

      await repository.postFileForDocumentManagement("General/CreateModuleFile", event.target.files, "fileList", this.moduleIdProp, this.moduleNameProp, "file", resultConfirm2.value);
      await this.GetFileList();
      this.$vs.loading.close();
    },

    DeleteDocumentManagementFile: async function(item) {
      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: "Dosya kalıcı olarak silinecektir",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();

      await this.DocumentSystemDeleteModuleFile(item);

      await this.GetFileList();
      this.$vs.loading.close();
    },

    showImg(index) {
      this.index = index;
      this.lightBoxVisible = true;
    },
    //hide pic with click
    handleHide() {
      this.lightBoxVisible = false;
    },

    getPath(path) {
      console.log(path);
      let fullPath = require(path);

      //fullPath = require("./assets/themes/blue/icons/" +path);

      console.log(fullPath);
    },

    FileManagerPopupClosedChildEmit: async function(item) {
      this.$emit("FileManagerPopupClosedChildEmit", item);
    },
    GetFileList: async function() {
      this.fileList = await repository.postEntity("General/GetFileList", { moduleName: this.modulNameProp, moduleId: this.moduleIdProp }).then((r) => r.list);
      console.log(this.fileList);
    },
    SaveDocumentManagementFile: async function(item, operation) {
      this.$vs.loading();
      item.operation = operation;
      this.fileList = await repository.postEntity("General/SaveDocumentManagementFile", item).then((r) => r.list);
      this.GetFileList();
      this.$vs.loading.close();
    },

    // GetImageStream: async function(fileItem) {
    //   let a;
    //   fileItem.pngBase64 = await repository
    //     .DownloadStream("General/DownloadPngFile" + "/" + fileItem.moduleName + "/" + fileItem.moduleId + "/" + fileItem.name)
    //     .then((response) => response.blob())
    //     .then(
    //       (blob) =>
    //         new Promise((callback) => {
    //           let reader = new FileReader();
    //           reader.onload = function() {
    //             callback(this.result);
    //           };
    //           reader.readAsDataURL(blob);
    //         })
    //     );
    //},

    // DownloadModuleFile: async function(fileItem) {
    //   this.$vs.loading();
    //   fileItem.pngBase64 = await repository
    //     .DownloadStream("General/DownloadModuleFile" + "/" + fileItem.moduleName + "/" + fileItem.moduleId + "/" + fileItem.name)
    //     .then((response) => response.blob())
    //     .then((blob) => {
    //       var url = window.URL.createObjectURL(blob);
    //       var a = document.createElement("a");
    //       a.href = url;
    //       a.download = fileItem.name;
    //       document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
    //       a.click();
    //       a.remove(); //afterwards we remove the element again
    //     });
    //   this.$vs.loading.close();
    // },
  },

  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        if (this.showPopupPictureTool) this.showPopupPictureTool = false;
        else if (this.lightBoxVisible) this.lightBoxVisible = false;
        else this.FileManagerPopupClosedChildEmit();
      }
    });
  },
  created: async function() {
    await Promise.all([this.GetFileList()]);
  },
};
</script>

<style lang="scss">
.vs-dialog .vs-dialog-text {
  height: 99%;
  overflow-x: hidden;
  overflow-y: hidden;
}

.ankaCropper__saveButton {
  height: 33px;
}
.ankaCropper__navButton {
  padding: 0;
}
</style>
